module.exports = __webpack_public_path__ + "img/30_29.00597ed9.png";